// extracted by mini-css-extract-plugin
export var activityContainer = "_nr-0";
export var typingIndicatorContainer = "_nr-1";
export var typingIndicatorDot = "_nr-2";
export var wave = "_nr-3";